export default {
  'meta': {
    'langName': 'ROMANIAN',
    'lang': 'Română'
  },
  'title': 'RECHEMARE PRODUS COȘ DE BASCHET B900 BOX NBA TARMAK',
  'description': 'Salut,\n\nAi achiziționat recent un coș de baschet Tarmak B900 BOX NBA și îți mulțumim pentru cumpărătură.\n\nCa parte a angajamentului nostru continuu față de calitatea și siguranța produselor, echipa DECATHLON Baschet a identificat un risc potențial ca stâlpul să cadă vertical dacă manivela de reglare a înălțimii este îndepărtată, iar produsul este apoi manipulat sau utilizat.\n\nTe rugăm să răspunzi la câteva întrebări pentru a-ți putea oferi soluția de siguranță potrivită pentru produsul tău.\n\nNe cerem scuze pentru neplăcerile create și îți mulțumim pentru încredere.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'În primul rând, ați putea, vă rog, să confirmați adresa dumneavoastră de email și țara de reședință:'
  },
  'fields': {
    'country': 'Tara',
    'address': 'Adresa e-mail',
    'email': 'Adresa e-mail',
    'phonePrefix': 'Prefixul international al numarului de telefon',
    'phone': 'Număr de telefon',
    'validations': {
      'phoneOrEmail': 'Vă rugăm să ne furnizați cel puțin o adresă de email sau un număr de telefon.',
      'email': 'Te rog să introduci o adresă de email validă',
      'phone': 'Te rog să introduci un număr de telefon valid'
    },
    'firstName': 'Nume',
    'lastName': 'Prenume',
    'deliveryAddress': 'Adresa de livrare pentru pachet',
    'additionalAddress': 'Informatii suplimentare adresă',
    'city': 'Oras',
    'zip': 'Cod Postal',
    'choose': 'Selectează',
    'required': 'Acest câmp este obligatoriu'
  },
  'ownerCheck': {
    'title': '---\nMai dețineți unul sau mai multe coșuri de baschet B900 BOX NBA?'
  },
  'yes': 'DA',
  'no': 'NU',
  'ownerChanged': {
    'title': 'Ai datele de contact ale actualului(lor) proprietar(i)?',
    'confirmation': '---\nDomnule/Doamnă,\n\nVă mulțumim pentru participarea la această inițiativă de calitate.\n\nNe cerem scuze pentru neplăcerile create și vă mulțumim pentru încredere.\n\nDECATHLON'
  },
  'recall': {
    'title': '---\nTe rugăm să indici numărul de coșuri de baschet pe care le deții, în funcție de tipul manivelei instalate.',
    'descriptionRed': 'Coș de baschet cu manivelă roșie detașabilă',
    'descriptionBlack': 'Coș de baschet cu manivelă neagra fixă',
    'quantity': 'Cantitatea',
    'notConcerned': '---\nDomnule/Doamnă,\n\nVă mulțumim pentru participarea la această inițiativă de calitate.\n\nVă asigurăm că acest coș de baschet Tarmak B900 BOX NBA nu este afectat de procesul de rechemare. Este sigur de utilizat.\n\nNe cerem scuze pentru eventualele neplăceri și vă mulțumim pentru încredere.\n\nDECATHLON',
    'concernedProductQuantity': 'Cantitate de produs neconformă:',
    'concernedProductLabel': 'Produs neconform:',
    'confirmation': 'Mulțumim că ai completat acest formular. Solicitarea ta a fost înregistrată cu succes.\n\nÎți vom trimite numărul de urmărire pentru livrarea kitului cât mai curând posibil (prin FandiWeb pentru țările europene / prin X pentru țările non-europene).\n\nÎți dorim o zi excelentă!\n\nDECATHLON'
  },
  'repair': {
    'title': 'Reparație cu participarea ta',
    'description': '---\nAm detectat un risc de cădere verticală a stâlpului la anumite coșuri de baschet TARMAK B900 BOX NBA, ref. 4239136, dacă manivela este îndepărtată și produsul este manipulat sau utilizat.\n\nConform răspunsului dumneavoastră, produsul dumneavoastră pare să fie afectat de acest risc.\n\nPrin urmare, vă rugăm să încetați imediat utilizarea acestuia și vă oferim asistență pentru adaptarea manivelei, astfel încât să vă puteți folosi produsul în siguranță.\n\nFiți fără grijă, această reparație nu necesită expertiză specială — totul este explicat clar în videoclipul și manualul de instrucțiuni de mai jos:',
    'videoLink': 'Link Video',
    'docLink': 'Link Notificare',
    'callToAction': 'Apasă aici pentru a primi kitul tău gratuit de reparații',
    'warranty': 'Întregul proces este acoperit de garanția noastră de 5 ani.'
  },
  'repairRequest': {
    'title': 'Te rugăm să introduci următoarele informații pentru ca kitul tău gratuit să poată fi trimis la adresa aleasă de tine:'
  },
  'form': {
    'submit': 'Următorul'
  },
  'status': 'Translation validated by COUNTRY'
} as const
